module.exports = __webpack_public_path__ + "img/enlarge.2c171d75.svg";